import { useContext } from "react";
import { OaRVaRLayout } from "./layout/OaRVaRLayout";
import { ChartSection } from "../../layout/ChartSection";
import { RefProvider } from "./store/RefContext";
import { LayoutProvider } from "./store/LayoutContext";
import { LocalStoreProvider } from "./store/LocalStore";
import { StoreContext } from "../../store/Store";

export const OaRVaR = () => {
  const [store] = useContext(StoreContext);
  const { dimensions } = store;
  return (
    <ChartSection header="" height={dimensions.vh}>
      <LayoutProvider>
        <RefProvider>
          <LocalStoreProvider>
            <OaRVaRLayout />
          </LocalStoreProvider>
        </RefProvider>
      </LayoutProvider>
    </ChartSection>
  );
};
